export const toTableRowItems = (items: DeliveryTruck[]) =>
  items.map((item: DeliveryTruck) => ({
    id: item.id || '',
    approveDate: item.approveDate || '',
    arrivalConform: item.arrivalConform || false,
    deliveredShopCode: item.deliveredShopCode || '',
    deliveredShopCodeName: item.deliveredShopCodeName || '',
    deliveryTicketCreated: item.deliveryTicketCreated || '',
    deliveryTickets: item.deliveryTickets || '',
    deliveryType: item.deliveryType || '',
    depositIds: item.depositIds || '',
    depositType: item.depositType || '',
    driverName: item.driverName || '',
    expectedDeliveryDate: item.expectedDeliveryDate || '',
    flowType: item.flowType || '',
    hubReceived: item.hubReceived || '',
    hubSent: item.hubSent || '',
    sealConform: item.sealConform || false,
    driverEquipped: item.driverEquipped || false,
    driverAssisted: item.driverAssisted || false,
    false: item.false || '',
    shopCode: item.shopCode || '',
    shopName: item.shopName || '',
    status: item.status || '',
    supportCount: item.supportCount || '',
    thermodiagramConform: item.thermodiagramConform || false,
    transportCode: item.transportCode || '',
    truckCreated: item.truckCreated || '',
    truckId: item.truckId || '',
    truckNumber: item.truckNumber || ''
  }))
